<template>
  <v-carousel v-model="model" light hide-delimiters :show-arrows="false" height="auto">
    <v-carousel-item>
      <download-books-table @templateSelected="showPrintOptions"/>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import DownloadBooksTable from "./DownloadBooksTable.vue";
export default {
  components: { DownloadBooksTable },
  name: "DownloadBooksHome",
  data() {
    return {
      model: 0,
    };
  },
  methods: {
      showPrintOptions(){
          this.model = 1;
      },
      showTemplates(){
        this.$refs.printOptions.resetValues();
        this.model = 0;
      }
  }
};
</script>